module.exports = __webpack_public_path__ + "static/img/bottom-dc.5bbb51c4.png";